// 引入vue实例
import Vue from 'vue'
// 引入根组件
import App from './App.vue'
// 引入路由
import router from './router'
// 引入vuex
import store from './store'

// 全局引入bootstrap组件库
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './utils/element.js'
// 设计变量 & 通用样式
import '@/styles/variables.css'
import '@/styles/index.css'

Vue.use(BootstrapVue)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
